import styled from '@emotion/styled';

const BADGE_COLOR = {
  RED: 'red',
  GREEN: 'green',
  ORANGE: 'orange',
} as const;

const BADGE_SIZE = {
  SMALL: 'small',
  BIG: 'big',
} as const;

const getBackgroundColor = (color, theme) => {
  let backgroundColor;
  switch (color) {
    case BADGE_COLOR.RED:
      backgroundColor = theme.colors?.red[600];
      break;
    case BADGE_COLOR.GREEN:
      backgroundColor = theme.colors?.green[600];
      break;
    case BADGE_COLOR.ORANGE:
      backgroundColor = theme.colors?.orange[300];
      break;
    default:
      backgroundColor = theme.colors?.green[600];
  }
  return backgroundColor;
};

const StyledBadge = styled<any>('span')((props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  borderRadius: '50%',
  lineHeight: '150%',
  minHeight: props.size === BADGE_SIZE.SMALL ? '16px' : '20px',
  minWidth: props.size === BADGE_SIZE.SMALL ? '16px' : '20px',
  color: props.theme.colors?.white,
  backgroundColor: getBackgroundColor(props.color, props.theme),
  fontSize:
    props.size === BADGE_SIZE.SMALL
      ? props.theme.functions?.pixelsToRem(10)
      : props.theme.functions?.pixelsToRem(12),
}));

type BadgeProps = {
  content?: React.ReactNode;
  description?: string;
  color?: (typeof BADGE_COLOR)[keyof typeof BADGE_COLOR];
  size?: (typeof BADGE_SIZE)[keyof typeof BADGE_SIZE];
};

const Badge = ({ content, description, color, size }: Readonly<BadgeProps>) => {
  return (
    <StyledBadge color={color} size={size} id={`${description}Count`}>
      {content}
    </StyledBadge>
  );
};

Badge.defaultProps = {
  size: BADGE_SIZE.SMALL,
};

export default Badge;
